import { render, staticRenderFns } from "./FallRiskBadge.vue?vue&type=template&id=01128432&scoped=true&"
import script from "./FallRiskBadge.vue?vue&type=script&lang=js&"
export * from "./FallRiskBadge.vue?vue&type=script&lang=js&"
import style0 from "./FallRiskBadge.vue?vue&type=style&index=0&id=01128432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01128432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
